import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-document-management-system',
    templateUrl: './document-management-system.component.html',
    styleUrls: ['./document-management-system.component.css']
})
export class DocumentManagementSystemComponent implements OnInit {
    display: boolean = false;
    fileList: Array<any> = [];
    patientList: Array<any> = [];
    patient:any=[];
    imagebrows: any;
    name: String = '';
    MobileNo: number;
    Age: String = '';
    Gender: String = '';
    Mailid: String = ''
    Address: String = '';
    xyz: any;

    constructor() {
    }

    ngOnInit() {
        this.patientList.push([1, 'Shamali Raut', 1233245, 5456823932, 'rautshamali@gmail.com', 'Female', '0000',24,'pune']);
        this.patientList.push([2, 'Minali Sanadi', 1233246, 5466453932, 'minalisanadi@gmail.com', 'Female', '11111',42,'vashi']);
        this.patientList.push([3, 'Pooja Balsaraf', 1233247, 546453932, 'Bpooja@gmail.com', 'Female', '222222',23,'mumbai']);
        this.patientList.push([4, 'Gauri Joshi', 1233248, 546453932, 'jgauri@gmail.com', 'Female', '33333',34,'pune']);
        this.patientList.push([5, 'Jitendra Patil', 1233250, 546453932, 'pjitendra@gmail.com', 'Male', '44444',25,'mumbai']);
        this.patientList.push([6, 'Chetan Patil', 1233251, 546453932, 'patilchetan@gmail.com', 'Male', '555555',35,'Aurangabad']);
        this.patientList.push([7, 'Shubham Kakde', 1233252, 546453932, 'kshubham@gmail.com', 'Male', '66666',45,'Amravati']);
        console.log('patientList', this.patientList);
        this.xyz = 0;
    }

    addRecord(id) {
        this.display = true;
        if (id == 1) {
            this.name = this.patientList[0][1];
            this.MobileNo = this.patientList[0][3];
            this.Age = this.patientList[0][7];
            this.Gender = this.patientList[0][5];
            this.Mailid = this.patientList[0][4];
            this.Address = this.patientList[0][8];
            this.xyz = 0;
            console.log('patient', this.patient);

        } else if (id == 2) {
            this.name = this.patientList[1][1];
            this.MobileNo = this.patientList[1][3];
            this.Age = this.patientList[1][7];
            this.Gender = this.patientList[1][5];
            this.Mailid = this.patientList[1][4];
            this.Address = this.patientList[1][8];
            this.xyz = 0;

        } else if (id == 3) {
            this.name = this.patientList[2][1];
            this.MobileNo = this.patientList[2][3];
            this.Age = this.patientList[2][7];
            this.Gender = this.patientList[2][5];
            this.Mailid = this.patientList[2][4];
            this.Address = this.patientList[2][8];
            this.xyz = 0;

        }
        else if (id == 4) {
            this.name = this.patientList[3][1];
            this.MobileNo = this.patientList[3][3];
            this.Age = this.patientList[3][7];
            this.Gender = this.patientList[3][5];
            this.Mailid = this.patientList[3][4];
            this.Address = this.patientList[3][8];
            this.xyz = 0;

        }
        else if (id == 5) {
            this.name = this.patientList[4][1];
            this.MobileNo = this.patientList[4][3];
            this.Age = this.patientList[4][7];
            this.Gender = this.patientList[4][5];
            this.Mailid = this.patientList[4][4];
            this.Address = this.patientList[4][8];
            this.xyz = 1;
        }
        else if (id == 6) {
            this.name = this.patientList[5][1];
            this.MobileNo = this.patientList[5][3];
            this.Age = this.patientList[5][7];
            this.Gender = this.patientList[5][5];
            this.Mailid = this.patientList[5][4];
            this.Address = this.patientList[5][8];
            this.xyz = 1;
        }
        else if (id == 7) {
            this.name = this.patientList[6][1];
            this.MobileNo = this.patientList[6][3];
            this.Age = this.patientList[6][7];
            this.Gender = this.patientList[6][5];
            this.Mailid = this.patientList[6][4];
            this.Address = this.patientList[6][8];
            this.xyz = 1;

        }

    }

    onTableClick(id) {
        if (id == 1) {
            this.fileList = [];
            this.fileList.push([1, 3.1, ' Medical history', '.bmp', 2390446, 'D:/patient/images']);
        } else if (id == 2) {
            this.fileList = [];
            this.fileList.push([1, 3.5, ' Progress notes', '.txt', 2390476, 'D:/patient/images']);
        } else if (id == 3) {
            this.fileList = [];
            this.fileList.push([1, 3.7, ' Test results', '.pdf', 2390456, 'D:/patient/images']);
        }
        else if (id == 4) {
            this.fileList = [];
            this.fileList.push([1, 3.9, ' Medical encounters', '.wpd', 2390478, 'D:/patient/images']);
        }
        else if (id == 5) {
            this.fileList = [];
            this.fileList.push([1, 4.1, ' Test results', '.txt', 2390465, 'D:/patient/images']);
        }
        else if (id == 6) {
            this.fileList = [];
            this.fileList.push([1, 3.2, ' Progress notes', '.pdf', 2390409, 'D:/patient/images']);
        }
        else if (id == 7) {
            this.fileList = [];
            this.fileList.push([1, 4.5, ' Medical history', '.pdf', 2390408, 'D:/patient/images']);
        }
    }

}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/document-management-system/document-management-system.component.ts